export const loadAgentLinksPeriodMilliseconds: number = 1 * 20 * 60 * 1000

export const whatsappContactLink = 'https://wa.me/595994588805'
